"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

var _baseDialogPropTypes = _interopRequireDefault(require("./baseDialogPropTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Component to show a modal popup containing a title, a content and a close handler.
 */
var SimpleDialog = function SimpleDialog(props) {
  var content = props.content,
      onClose = props.onClose,
      className = props.className;
  var dialogClassName = "".concat(className ? className : '', " simple-dialog");
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({}, props, {
    body: content,
    onHide: onClose,
    className: dialogClassName
  }));
};

SimpleDialog.defaultProps = {
  showCloseButton: true
};
SimpleDialog.propTypes = _objectSpread(_objectSpread({}, _baseDialogPropTypes.default), {}, {
  content: _propTypes.default.node
});
var _default = SimpleDialog;
exports.default = _default;